import { render } from "./OfficeAssignGrid.vue?vue&type=template&id=e2d1a1f4&scoped=true"
import script from "./OfficeAssignGrid.vue?vue&type=script&lang=js"
export * from "./OfficeAssignGrid.vue?vue&type=script&lang=js"

import "./OfficeAssignGrid.vue?vue&type=style&index=0&id=e2d1a1f4&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d1a1f4"]])

export default __exports__